module.exports = __webpack_public_path__ + "static/43-e6c7cd3766d12bdfc5ade4445e616b22.png";